/* CLAVAKIT cookie consent + consent-gated analytics.
   Rules: nothing analytic loads before an explicit choice; the choice persists
   for 180 days; the banner can be reopened from the footer; on Shopify, if the
   platform's own Customer Privacy banner is enabled the owner switches this
   one off in theme settings (window.CLAVAKIT.consent.enabled = false) and the
   platform's consent API drives the same loaders. */
(function () {
  'use strict';
  var w = window, d = document;
  var cfg = (w.CLAVAKIT && w.CLAVAKIT.consent) || {};
  var ids = (w.CLAVAKIT && w.CLAVAKIT.analytics) || {};   // { ga4, meta, tiktok }
  var KEY = 'ck_consent_v1';
  var banner = d.querySelector('.consent');
  var loaded = { analytics: false, marketing: false };

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || 'null'); if (v && v.exp > Date.now()) return v; } catch (e) {}
    return null;
  }
  function write(c) {
    var v = { analytics: !!c.analytics, marketing: !!c.marketing, exp: Date.now() + 180 * 864e5 };
    try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
    return v;
  }

  /* ---- loaders: each runs at most once and only after consent ------------- */
  function script(src) { var s = d.createElement('script'); s.async = true; s.src = src; d.head.appendChild(s); }
  function loadAnalytics() {
    if (loaded.analytics || !ids.ga4) return; loaded.analytics = true;
    w.dataLayer = w.dataLayer || [];
    w.gtag = function () { w.dataLayer.push(arguments); };
    w.gtag('js', new Date());
    w.gtag('config', ids.ga4, { anonymize_ip: true });
    script('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(ids.ga4));
  }
  function loadMarketing() {
    if (loaded.marketing) return; loaded.marketing = true;
    if (ids.meta) {
      if (!w.fbq) { var n = w.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; n.push = n; n.loaded = true; n.version = '2.0'; n.queue = []; }
      w.fbq('init', ids.meta); w.fbq('track', 'PageView');
      script('https://connect.facebook.net/en_US/fbevents.js');
    }
    if (ids.tiktok) {
      var t = w.TiktokAnalyticsObject = 'ttq'; var q = w[t] = w[t] || [];
      q.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'];
      q.setAndDefer = function (o, m) { o[m] = function () { o.push([m].concat(Array.prototype.slice.call(arguments, 0))); }; };
      for (var i = 0; i < q.methods.length; i++) q.setAndDefer(q, q.methods[i]);
      q._i = q._i || {}; q._i[ids.tiktok] = []; q._t = q._t || {}; q._t[ids.tiktok] = +new Date();
      script('https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=' + encodeURIComponent(ids.tiktok) + '&lib=ttq');
      q.page && q.page();
    }
  }
  function apply(c) {
    if (c.analytics) loadAnalytics();
    if (c.marketing) loadMarketing();
    d.dispatchEvent(new CustomEvent('clavakit:consent', { detail: c }));
  }

  /* ---- Shopify Customer Privacy bridge --------------------------------------- */
  function shopifyBridge() {
    if (!(w.Shopify && w.Shopify.customerPrivacy)) return false;
    var cp = w.Shopify.customerPrivacy;
    var sync = function () {
      apply({ analytics: cp.analyticsProcessingAllowed(), marketing: cp.marketingAllowed() });
    };
    d.addEventListener('visitorConsentCollected', sync);
    sync();
    return true;
  }

  /* ---- banner --------------------------------------------------------------- */
  function show() {
    if (!banner) return;
    banner.hidden = false;
    var first = banner.querySelector('button'); first && first.focus({ preventScroll: true });
  }
  function hide() { if (banner) banner.hidden = true; }
  function choose(c) { apply(write(c)); hide(); }

  if (banner) {
    banner.addEventListener('click', function (e) {
      var b = e.target.closest('[data-consent]'); if (!b) return;
      var mode = b.dataset.consent;
      if (mode === 'accept') choose({ analytics: true, marketing: true });
      else if (mode === 'reject') choose({ analytics: false, marketing: false });
      else if (mode === 'prefs') { var p = banner.querySelector('.consent__prefs'); p.hidden = !p.hidden; b.setAttribute('aria-expanded', String(!p.hidden)); }
      else if (mode === 'save') {
        choose({ analytics: banner.querySelector('[name=analytics]').checked, marketing: banner.querySelector('[name=marketing]').checked });
      }
    });
    banner.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); }); /* dismiss without choosing = no tracking */
  }
  d.addEventListener('click', function (e) {
    var a = e.target.closest('[data-open-consent]'); if (!a) return;
    e.preventDefault(); show();
  });

  /* ---- boot ----------------------------------------------------------------- */
  if (cfg.enabled === false) { shopifyBridge(); return; }   /* platform banner owns consent */
  var prior = read();
  if (prior) { apply(prior); hide(); }
  else if (!shopifyBridge()) { show(); }
})();
